module.exports = __webpack_public_path__ + "img/osszes_aktualis_kategoria_icon.8d83f8fb.svg";